export default "__VITE_ASSET__DgfavKHk__"